import { Button } from 'components/buttons/Button/Button';
import image from 'images/product-cards/product-card-0.jpg';
import { Link } from 'react-router-dom';

const ProductItem = ({ data, index }) => {
    const { logo, preview_title } = data;

    return (
        <Link to={'/#'} className="product-link">
            <div className="product-link__name">
                {preview_title}
                <div className="gradient-number dark">
                    <span>{index + 1}</span>
                </div>
            </div>
            {/* TODO ADD REAL IMAGES FROM ADMIN */}
            <div className="product-link__image" style={{ backgroundImage: `url(${image})` }}>
                <img src={logo} alt="product-logo" />
            </div>
            <div className="button learn-more-arrow">
                <div></div>
            </div>
        </Link>
    );
};

export default ProductItem;
